module.exports = __webpack_public_path__ + "img/fa88477f1c8be899bbd85057dc029b3c.svg";